var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.configData)?_c('div',{staticClass:"row"},_vm._l((_vm.configData),function(cd,index){return _c(cd.type,{key:_vm.fieldNameAsKey?cd.fieldName:index,tag:"component",attrs:{"form":_vm.form,"config":cd,"isCreateForm":_vm.isCreateForm,"pageMode":_vm.pageMode,"readonly":_vm.readolyMethod(cd),"languageCode":_vm.languageCode}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }